export enum ProductSize {
  DEFAULT = 1,
  SMALL = 2,
  FAMILY = 3,
  JUMBO = 4
}
export class ProductMeta {
  public name : string;
  public text : string;
  public size : ProductSize;
  public sizeIndex : number;
  public price : number;
  public priceSet;
  constructor(payload) {
    this.name = payload.name;
    this.text = payload.text;
    this.size = ProductMeta.getProductSizeByName(payload.size);
    this.price = parseFloat(payload.price);
  }

  public setSize(size : ProductSize) {
    this.size = size;
  }

  public getFormattedName(){
    return `${this.name.replace(/Default/, "Groß")} (${this.price}&euro;)</span>`;
  }

  getIngredientPrice(){
    let cost;
    switch (this.size){
      case ProductSize.DEFAULT:
        cost = 1.0;
        break;
      case ProductSize.SMALL:
        cost = 0.5;
        break;
      case ProductSize.FAMILY:
        cost = 1.5;
        break;
      default:
        cost = 1.0;
    }

    return cost;
  }
  getSize(){
    if (!this.priceSet){ return "Default"; }
    return this.priceSet[this.sizeIndex].name;
  }

  getPrice(){
    return this.price;
  }

  getPriceFormatted(){
    if (this.price.toString().indexOf(".") > -1){
      let suffix = this.price.toString().split(".");
      if (suffix[1].length == 1){
        suffix[1] = suffix[1] + "0";
      }
      return suffix.join(",");
    }
    return this.price.toString() + ",00";
  }

  static getProductSizeByName(name : string) : ProductSize {
    let size;
    if(!name){
      return ProductSize.DEFAULT;
    }
    switch (name.toLowerCase()){
      case "default":
      case "normal":
        size = ProductSize.DEFAULT;
        break;
      case "klein":
      case "small":
        size = ProductSize.SMALL;
        break;
      case "familie":
      case "big":
      case "family":
        size = ProductSize.FAMILY;
        break;
      default:
        size = ProductSize.DEFAULT;
    }
    return size;
  }
}



// WEBPACK FOOTER //
// ./src/app/classes/product_meta.ts